import { FilterHandler, useFilterState } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import Form from '../../../packages/kiti/components/form/form/Form'
import Line from '../../../packages/kiti/components/helpers/Line'
import Modal from '../../../components/structure/Modal'
import ModalPickerFooter from '../../../components/form/modalPicker/ModalPickerFooter'
import ModalPickerHeader from '../../../components/form/modalPicker/ModalPickerHeader'
import Picker from '../../../packages/kiti/components/form/picker/Picker'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import SelectAllUsersLink from '../SelectAllUsersLink'
import SelectableListItem from '../../../packages/kiti/components/list/SelectableListItem'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import UserFiltersList from '../filters/UserFiltersList'
import UsersLoader, { useUsers } from './_load/UsersLoader'

const Footer = ({ onClose, onChange, multiple, filter }) => {
  const { filter: filterState, search } = useFilterState()
  const { form, handleChangeIn } = useFormState()

  return (
    <ModalPickerFooter closeModal={onClose} onChange={onChange}>
      {!!multiple && (
        <SelectAllUsersLink
          onSelect={handleChangeIn([])}
          value={form}
          useRawValues
          search={search}
          filter={{ ...filterState, ...filter }}
        />
      )}
    </ModalPickerFooter>
  )
}

const Content = props => {
  const options = useUsers()
  const { form, handleChangeIn } = useFormState()

  return (
    <Picker
      Selector={SelectableListItem}
      options={options}
      value={form || []}
      onChange={handleChangeIn([])}
      idField="id"
      labelField="name"
      descriptionField="email"
      {...props}
    />
  )
}

const UserPickerModal = ({ open, onClose, value, onChange, level, ...props }) => {
  const { t } = useTranslation('users')

  return (
    <Modal width="42rem" noPadding open={open} onClose={() => onClose()} level={level}>
      <FilterHandler>
        <Form initialState={value || []}>
          <ModalPickerHeader
            title={t('selectUsers')}
            filtersList={<UserFiltersList level={level || 1 + 1} />}
            useDeletedOption
            useDisabledOption
            {...props}
          />
          <Line />

          <Scroll height="65vh">
            <UsersLoader>
              <Content closeModal={onClose} {...props} />
            </UsersLoader>
            <Separator weight={12} />
          </Scroll>

          <Line />
          <Footer onClose={onClose} onChange={onChange} {...props} />
        </Form>
      </FilterHandler>
    </Modal>
  )
}

export default UserPickerModal
